import { usePublicationDetailDispatch } from './publication-detail-context';
import { ACTION_TYPES } from './publication-detail-reducer';
import PortalAppService from '../../../application/platform/portal-app-service';

export function usePublicationDetailController() {
    const dispatch = usePublicationDetailDispatch();

    const loadDetail = async (id: number) => {
        try {
            dispatch({ type: ACTION_TYPES.SET_LOADING, payload: true });
            const data = await PortalAppService.requestPublicationDetail(id);
            dispatch({ type: ACTION_TYPES.SET_PUBLICATION_DETAIL, payload: data });
        } catch (error: any) {
            console.error('Error loading publication detail:', error);
            dispatch({
                type: ACTION_TYPES.SET_ERROR,
                payload: error?.message || 'Não foi possível carregar os detalhes da publicação'
            });
        }
    };

    return {
        loadDetail
    };
}
